import { render, staticRenderFns } from "./addBpid.vue?vue&type=template&id=d4ebd79c&scoped=true&"
import script from "./addBpid.vue?vue&type=script&lang=js&"
export * from "./addBpid.vue?vue&type=script&lang=js&"
import style0 from "./addBpid.vue?vue&type=style&index=0&id=d4ebd79c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebd79c",
  null
  
)

export default component.exports